const TIKTOK_URL = "https://www.tiktok.com/@securycles.serrur?_t=8k12IzZz8Fs&_r=1";

export default function CtaSection() {
  return (
    <section className="py-20 md:py-28 bg-black relative overflow-hidden">
      {/* Diagonal stripes */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #FFB100 0px, #FFB100 4px, transparent 4px, transparent 40px)",
        }}
      ></div>

      <div className="relative max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-[#FFB100]/20 text-[#FFB100] text-xs font-black px-3 py-1.5 rounded-full mb-6 uppercase tracking-widest">
          <i className="ri-alarm-warning-line"></i>
          Besoin d&apos;un serrurier ?
        </div>
        <h2 className="text-4xl md:text-5xl font-black text-white uppercase leading-tight mb-6">
          Urgence
          <br />
          <span className="text-[#FFB100]">Serrurerie</span>
          <br />
          24h/24 • 7j/7
        </h2>

        {/* Features */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {[
            "Intervention 20 min",
            "Devis transparent",
            "Serrurier certifié",
            "Sans casse garanti",
          ].map((item) => (
            <span key={item} className="flex items-center gap-1.5 text-gray-300 text-sm bg-white/5 px-3 py-1.5 rounded-full">
              <i className="ri-check-line text-[#FFB100] text-xs"></i>
              {item}
            </span>
          ))}
        </div>

        {/* TikTok */}
        <a
          href={TIKTOK_URL}
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-flex items-center gap-2 border border-gray-700 text-gray-400 text-sm px-4 py-2 rounded-full hover:border-[#FFB100] hover:text-[#FFB100] transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-tiktok-line"></i>
          Suivez-nous @securycles.serrur
        </a>
      </div>
    </section>
  );
}
